<template>
  <div>
    <nav-bar />
    <section>
      <div class="banner">
        <img src="../assets/forum_img/banner.png" alt="" />
      </div>
      <div class="gift">
        <div class="title">
          <p>三重好礼免费送</p>
          <div></div>
          <span>免费送好礼 特权享不停</span>
        </div>
        <ul>
          <li @click="$router.push('/Baojia')">
            <img src="../assets/forum_img/gift1.png" alt="" class="gift_l" />
            <div class="gift_m">
              <span>凭预约短信</span>
              <p>可免费领取</p>
              <p>停车券</p>
              <img src="../assets/forum_img/collect.png" alt="" />
            </div>
            <img
              src="../assets/forum_img/collect_r.png"
              alt=""
              class="gift_r"
            />
          </li>
          <li @click="$router.push('/Baojia')">
            <img src="../assets/forum_img/gift2.png" alt="" class="gift_l" />
            <div class="gift_m">
              <span>现场下定</span>
              <p>即可参与</p>
              <p>抽盲盒活动</p>
              <img src="../assets/forum_img/collect.png" alt="" />
            </div>
            <img
              src="../assets/forum_img/collect_r.png"
              alt=""
              class="gift_r"
            />
          </li>
          <li @click="$router.push('/Baojia')">
            <img src="../assets/forum_img/gift3.png" alt="" class="gift_l" />
            <div class="gift_m">
              <span>定装修</span>
              <p>即可享受</p>
              <p>12重好礼</p>
              <img src="../assets/forum_img/collect.png" alt="" />
            </div>
            <img
              src="../assets/forum_img/collect_r.png"
              alt=""
              class="gift_r"
            />
          </li>
        </ul>
        <div class="money">
          <div class="title">
            <p>怎么装优选整装产品</p>
            <div></div>
            <span>颜值过人 舒适过分</span>
          </div>
          <van-swipe :autoplay="2000" class="money_">
            <van-swipe-item
              v-for="(item, index) in images"
              :key="index"
              @click="$router.push('/Baojia')"
            >
              <img v-lazy="item.image" />
            </van-swipe-item>
          </van-swipe>
          <div class="submit">
            <button @click="$router.push('/Baojia')">立即预约</button>
            <div class="prompt">
              *确保您的隐私与我们的声誉，您的信息将被严格保密。
            </div>
          </div>
        </div>
      </div>
      <div class="style">
        <div class="title">
          <p>怎么装优选整装产品</p>
          <div></div>
          <span>颜值过人 舒适过分</span>
        </div>
        <van-swipe :autoplay="3000" class="style_item">
          <van-swipe-item
            v-for="(item, index) in style"
            :key="index"
            @click="$router.push('/Baojia')"
          >
            <img :src="item.image" alt="" />
          </van-swipe-item>
        </van-swipe>
        <div class="lateral-sliding">
          <div
            class="lateral-sliding-item"
            v-for="(item, index) in style_s"
            :key="index"
          >
            <img :src="item" alt="" />
          </div>
        </div>
        <div class="submit">
          <button @click="$router.push('/Baojia')">立即预约</button>
          <div class="prompt">
            *确保您的隐私与我们的声誉，您的信息将被严格保密。
          </div>
        </div>
      </div>
      <div class="designer">
        <div class="title">
          <p>金牌设计师 一对一服务</p>
          <div></div>
          <span>沪上资深设计团队 平均10+设计经验</span>
        </div>

        <ul class="designer_t">
          <li class="designer_tl">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_tl"
              :key="index"
            />
          </li>
          <li class="designer_tr">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_tr"
              :key="index"
            />
          </li>
        </ul>
        <ul class="designer_m">
          <li class="designer_ml">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_ml"
              :key="index"
            />
          </li>
          <li class="designer_mm">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_mm"
              :key="index"
            />
          </li>
          <li class="designer_mb">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_mr"
              :key="index"
            />
          </li>
        </ul>
        <ul class="designer_b">
          <li class="designer_bl">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_bl"
              :key="index"
            />
          </li>
          <li class="designer_bm">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_bm"
              :key="index"
            />
          </li>
          <li class="designer_bb">
            <img
              :src="item.image"
              alt=""
              v-for="(item, index) in designer_br"
              :key="index"
            />
          </li>
        </ul>

        <ul class="style_b">
          <li v-for="(item, index) in style_b" :key="index">
            <img :src="item.image" alt="" />
          </li>
        </ul>
      </div>
      <div class="show">
        <div class="show_t">
          <div class="title">
            <p>五千平建材展厅 选材轻松搞定</p>
            <div></div>
            <span>从房子到家 不用奔波买材料 省心顺利住新家</span>
          </div>
          <ul>
            <li>
              <img src="../assets/forum_img/right.png" alt="" />
              <span>强势整合资源 厂家直供</span>
            </li>
            <li>
              <img src="../assets/forum_img/right.png" alt="" />
              <span>10大主材品牌 样样爆款 新低价格</span>
            </li>
            <li>
              <img src="../assets/forum_img/right.png" alt="" />
              <span>全屋材料 安全环保更放心</span>
            </li>
          </ul>
        </div>
        <div class="show_slide">
          <van-swipe :autoplay="3000" class="show_item">
            <van-swipe-item
              v-for="(item, index) in brand"
              :key="index"
              @click="$router.push('/Baojia')"
            >
              <img :src="item.image" alt="" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="show_b">
          <p><span>品牌建材</span> 款式多样随心配</p>
          <p>主材、辅材、家具、软装、配饰</p>
          <div></div>
        </div>
        <div class="submit">
          <button @click="$router.push('/Baojia')">立即预约</button>
          <div class="prompt">
            *确保您的隐私与我们的声誉，您的信息将被严格保密。
          </div>
        </div>
      </div>
      <div class="craft">
        <div class="title">
          <p>特色施工工艺 标准更严苛</p>
          <div></div>
          <span>18大特色工艺 68道工序 </span>
        </div>
        <ul>
          <li
            @click="choose(item, index)"
            :class="{ craft_a: categoryIndex == index }"
            v-for="(item, index) in craft"
            :key="index"
          >
            {{ item.name }}
          </li>
        </ul>

        <van-swipe
          :autoplay="2000"
          class="craft_item"
          lazy-render
          @change="onChange"
          ref="swipe"
        >
          <van-swipe-item
            v-for="(item, index) in craft"
            :key="index"
            @click="$router.push('/Baojia')"
          >
            <img :src="item.image" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="haipai">
        <div class="title">
          <p>海派精工 特色工艺</p>
          <div></div>
          <span> 怎么装独创特色工艺 </span>
        </div>
        <ul>
          <li v-for="(item, index) in haipai" :key="index">
            <img :src="item.image" alt="" />
            <div>
              <p>{{ item.name }}</p>
              <p>{{ item.desc }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="team">
        <div class="team_t">
          <div class="title">
            <p>扁平化管理 严格监管施工队伍</p>
            <div></div>
            <span> 标准化施工工艺 每一队伍皆是自有严选 安心交付 </span>
          </div>
        </div>
        <ul>
          <li><img src="../assets/forum_img/team1.png" alt="" /></li>
          <li><img src="../assets/forum_img/team2.png" alt="" /></li>
        </ul>
        <div class="team_end">
          <img src="../assets/forum_img/team3.png" alt="" />
        </div>
        <div class="submit">
          <button @click="$router.push('/Baojia')">立即预约</button>
          <div class="prompt">
            *确保您的隐私与我们的声誉，您的信息将被严格保密。
          </div>
        </div>
      </div>

      <div class="map">
        <h5>交通指南</h5>
        <div class="forum_map">
          <div id="container"></div>

          <ul>
            <li>
              <p>活动时间</p>
              <div>
                <span>2022年3月26日-27日（9:00-19.30）</span>
              </div>
            </li>
            <li>
              <p>活动地点</p>
              <div>
                <span>上海市徐汇区桂林路418号2号楼</span>
              </div>
            </li>
            <li>
              <p>地铁路线</p>
              <div>
                <span>轨道交通9号 15号线桂林路站8号口</span>
              </div>
            </li>
            <li>
              <p>公交路线</p>
              <div>
                <span>205路 804路至钦州北路桂林路</span>
                <span>113路 721路 820路至桂林路钦江路</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import NavBar from "@/components/common/Navbar.vue";
import Footer from "@/components/common/Footer.vue";
import Vue from "vue";
import { Lazyload } from "vant";

Vue.use(Lazyload);
export default {
  name: "",
  components: {
    NavBar,
    Footer,
  },
  props: {},
  data() {
    return {
          map: '',
      mapZoom: 18,
      categoryIndex: 0,

      images: [
        // require("../assets/forum_img/899.png"),
        // require("../assets/forum_img/1499.png"),
      ],
      style_s: [
        require("../assets/forum_img/style_s1.png"),
        require("../assets/forum_img/style_s2.png"),
        require("../assets/forum_img/style_s3.png"),
        require("../assets/forum_img/style_s4.png"),
        require("../assets/forum_img/style_s5.png"),
        require("../assets/forum_img/style_s6.png"),
      ],
      style: [
        // require("../assets/forum_img/style1.jpg"),
        // require("../assets/forum_img/style2.jpg"),
        // require("../assets/forum_img/style3.jpg"),
        // require("../assets/forum_img/style4.jpg"),
        // require("../assets/forum_img/style5.jpg"),
        // require("../assets/forum_img/style6.jpg"),
        // require("../assets/forum_img/style7.jpg"),
        // require("../assets/forum_img/style8.jpg"),
      ],
      designer_tl: [
        // require("../assets/forum_img/designer1.png")
      ],
      designer_tr: [
        // require("../assets/forum_img/designer2.png"),
        // require("../assets/forum_img/designer3.png"),
        // require("../assets/forum_img/designer4.png"),
        // require("../assets/forum_img/designer5.png"),
        // require("../assets/forum_img/designer6.png"),
        // require("../assets/forum_img/designer7.png"),
      ],
      designer_ml: [
        // require("../assets/forum_img/designer8.png"),
        // require("../assets/forum_img/designer9.png"),
        // require("../assets/forum_img/designer10.png"),
        // require("../assets/forum_img/designer11.png"),
      ],
      designer_mm: [
        // require("../assets/forum_img/designer12.png")
      ],
      designer_mr: [
        // require("../assets/forum_img/designer13.png"),
        // require("../assets/forum_img/designer14.png"),
      ],
      designer_bl: [
        // require("../assets/forum_img/designer15.png")
      ],
      designer_bm: [
        // require("../assets/forum_img/designer16.png")
      ],
      designer_br: [
        // require("../assets/forum_img/designer17.png"),
        // require("../assets/forum_img/designer18.png"),
        // require("../assets/forum_img/designer19.png"),
        // require("../assets/forum_img/designer20.png"),
      ],
      style_b: [
        // require("../assets/forum_img/style_b1.png"),
        // require("../assets/forum_img/style_b2.png"),
        // require("../assets/forum_img/style_b3.png"),
        // require("../assets/forum_img/style_b4.png"),
      ],
      brand: [
        // require("../assets/forum_img/brand1.png"),
        // require("../assets/forum_img/brand2.png"),
        // require("../assets/forum_img/brand3.png"),
        // require("../assets/forum_img/brand4.png"),
      ],
      craft: [
        // require("../assets/forum_img/craft1.jpg"),
        // require("../assets/forum_img/craft2.jpg"),
        // require("../assets/forum_img/craft3.jpg"),
        // require("../assets/forum_img/craft4.jpg"),
      ],
      // craft_t: ["电路", "防水", "墙面", "地面"],
      haipai: [
        // {
        //   image: require("../assets/forum_img/haipai1.png"),
        //   tit: "防水施工",
        //   title: " 由专业的施工团队施工",
        // },
        // {
        //   image: require("../assets/forum_img/haipai2.png"),
        //   tit: "轻钢龙骨 ",
        //   title: "防开裂特色工艺",
        // },
        // {
        //   image: require("../assets/forum_img/haipai3.png"),
        //   tit: "石膏板吊顶 ",
        //   title: "转角防开裂特色工艺",
        // },
        // {
        //   image: require("../assets/forum_img/haipai4.png"),
        //   tit: "湿区门套 ",
        //   title: "防水特色工艺",
        // },
        // {
        //   image: require("../assets/forum_img/haipai5.png"),
        //   tit: "淋浴区",
        //   title: "现浇止水带防水特色工艺",
        // },
        // {
        //   image: require("../assets/forum_img/haipai6.png"),
        //   tit: "镜前灯 ",
        //   title: "鹰嘴特色工艺",
        // },
        // {
        //   image: require("../assets/forum_img/haipai7.png"),
        //   tit: "强弱电 ",
        //   title: "防干扰屏蔽特色工艺",
        // },
        // {
        //   image: require("../assets/forum_img/haipai8.png"),
        //   tit: "接线端子 ",
        //   title: "3.0特色工艺",
        // },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.geytForumList();
    this.getDesigner();
    // 地图
       this.$nextTick(() => {
      this.initMap()
    })
  },
  mounted() {},
  methods: {
    async geytForumList() {
      const res = await this.$http.get("activityImg");
      // console.log(res.data);
      this.images = res.data.one;
      this.style = res.data.two;
      this.brand = res.data.three;
      this.craft = res.data.four;
      this.haipai = res.data.five;
    },
    async getDesigner() {
      const res = await this.$http.get("activityDes");
      // console.log(res.data);
      this.designer_tl = res.data.one;
      this.designer_tr = res.data.two;
      this.designer_ml = res.data.three;
      this.designer_mm = res.data.four;

      this.designer_mr = res.data.five;
      this.designer_bl = res.data.six;
      this.designer_bm = res.data.seven;
      this.designer_br = res.data.eight;
    },

    choose(item, index) {
      this.categoryIndex = index;
      this.$refs.swipe.swipeTo(index);
      //  console.log(this.$refs.swipe);
    },
    onChange(index) {
      // console.log(index);
      this.categoryIndex = index;
    },
    	// 初始化地图
  	initMap() {
      // 创建Map实例
            this.map = new BMapGL.Map("container");
      // 初始化地图,设置中心点坐标和地图级别
      this.map.centerAndZoom(new BMapGL.Point(121.421037, 31.184035), this.mapZoom)
      // 启用滚轮放大缩小，默认禁用
      this.map.enableScrollWheelZoom(true)
      // 启用地图惯性拖拽，默认禁用
      this.map.enableContinuousZoom(true)
    }
  },
};
</script>

<style scoped lang="scss">
.title {
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 21px;
    font-family: "FZTYSK";
    font-weight: bold;
    color: #3e3a39;
  }
  div {
    width: 40px;
    height: 1px;
    background: #3e3a39;
    margin-top: 5px;
    margin-bottom: 7px;
  }
  span {
    font-size: 12px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #000000;
  }
}
.submit {
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    margin: 0 auto;
    width: 220px;
    height: 30px;
    background: #ffe100;
    border-radius: 5px 5px 5px 5px;
    border: none;
    font-size: 15px;
    font-family: "Lantinghei SC";
    font-weight: 400;
    color: #0a0b06;
    text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
    margin-bottom: 4px;
  }
  .prompt {
    width: 100%;
    text-align: center;
    font-size: 7px;
    font-family: "Lantinghei SC";
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
section {
  background-color: #ffffff;
  width: 100%;
  .banner {
    width: 100%;
    margin-bottom: 26px;
    img {
      width: 100%;
    }
  }
  .gift {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    margin-bottom: 50px;

    ul {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 50px;

      li {
        width: 100%;
        height: 130px;
        display: flex;
        margin-bottom: 7px;
        box-shadow: darkgray 0px 0px 5px 0px;
        .gift_l {
          width: 50%;
        }
        .gift_m {
          width: 50%;
          padding-left: 17px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          span {
            font-size: 10px;
            font-family: "FZLanTingHeiS-R-GB";
            font-weight: 400;
            color: #303030;
            margin-bottom: 2px;
          }
          p {
            font-size: 12px;
            font-family: "FZLanTingHeiS-B-GB";
            font-weight: bold;
            color: #303030;
            margin-bottom: 2px;
          }
          img {
            margin-top: 5px;
            width: 70px;
            height: 18px;
          }
        }
      }
    }
    .money {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .money_ {
        margin-top: 16px;
        width: 100%;
        margin-bottom: 30px;
        .van-swipe-item {
          width: 100%;
          img {
            width: 100%;
            // height: 100px;
          }
        }
      }
    }
  }
  .style {
    width: 100%;
    // height: 400px;
    background-image: url(../assets/forum_img/style_bg.png);
    background-size: cover;
    padding: 18px 0px;
    .title {
      margin-bottom: 20px;
      p {
        color: #fff;
      }
      div {
        background-color: #fff;
      }
      span {
        color: #fff;
      }
    }
    .style_item {
      width: 100%;
      .van-swipe-item {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
    .lateral-sliding {
      // margin-bottom: 10px;
      display: flex;
      overflow-y: hidden;
      overflow-x: scroll;
      scrollbar-width: none;
      width: 100%;
      .lateral-sliding-item {
        margin-right: 5px;
        img {
          width: 50px;
        }
      }
    }
    ::-webkit-scrollbar {
      width: 0 !important;
    }
    .submit {
      div {
        color: #fff;
      }
    }
  }
  .designer {
    width: 100%;
    box-sizing: border-box;
    padding: 40px 15px 25px 15px;
    background-color: #e6e8e9;
    .designer_t {
      width: 100%;
      display: flex;
      margin-top: 25px;
      .designer_tl {
        height: 139px;
        width: 40%;
        margin-right: 2px;
        margin-bottom: 2px;
        img {
          width: 100%;
          height: 137px;
        }
      }
      .designer_tr {
        width: 60%;
        height: 139px;
        overflow: hidden;
        display: flex;
        -webkit-display: flex;

        flex-wrap: wrap;
        img {
          float: right;
          width: 25%;
          // flex: 1;
          flex-grow: 1;
          // width: 32.1%;
          flex-shrink: 0;
          // -moz-box-flex: 1;
          margin-right: 2px;
          margin-bottom: 2px;
          &:nth-child(3n) {
            margin: none;
          }
        }
      }
    }
    .designer_m {
      width: 100%;
      display: flex;
      .designer_ml {
        width: 40%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        img {
          // flex: 1;
          flex-grow: 1;
          width: 40%;
          height: 70px;
          margin-right: 2px;
          margin-bottom: 2px;
        }
      }
      .designer_mm {
        width: 40%;
        margin-right: 2px;
        margin-bottom: 2px;
        img {
          width: 100%;
          height: 142px;
        }
      }
      .designer_mb {
        width: 20%;
        height: 142px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        img {
          float: left;
          width: 100%;
          height: 70px;
          overflow: hidden;
          margin-bottom: 2px;
        }
      }
    }

    .designer_b {
      width: 100%;
      display: flex;
      .designer_bl {
        width: 20%;
        margin-bottom: 2px;
        margin-right: 2px;
        img {
          width: 100%;
          height: 142px;
        }
      }
      .designer_bm {
        width: 40%;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        img {
          float: left;
          width: 100%;
          height: 142px;
          overflow: hidden;
          margin-right: 2px;
          margin-bottom: 2px;
        }
      }
      .designer_bb {
        width: 40%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;

        img {
          // flex: 1;
          flex-grow: 1;
          width: 40%;
          height: 70px;
          margin-right: 2px;
          margin-bottom: 2px;
          &:nth-child(2n) {
            margin: none;
          }
        }
      }
    }
    .style_b {
      width: 100%;
      display: flex;
      li {
        width: 25%;
        margin-right: 5px;
        padding-right: 5px;
        &:nth-last-child(1) {
          padding: 0;
        }
        img {
          width: 100%;
        }
      }
    }
  }
  .show {
    width: 100%;
    padding-bottom: 20px;
    .show_t {
      width: 100%;
      background: url(../assets/forum_img/map.png) no-repeat;
      background-size: cover;
      padding: 25px 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      ul {
        margin-top: 15px;
        // width: 100%;
        li {
          margin-bottom: 8px;
          img {
            width: 20px;
            height: 16px;
            margin-right: 5px;
            span {
              font-size: 10px;
              font-family: "Microsoft YaHei";
              font-weight: 400;
              color: #000000;
            }
          }
        }
      }
    }
    .show_slide {
      padding: 0 15px;
      .show_item {
        width: 100%;
        .van-swipe-item {
          width: 100%;
          img {
            width: 100%;
          }
        }
      }
    }
    .show_b {
      padding: 0 15px;
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        font-size: 16px;
        font-family: "FZLanTingHeiS-R-GB";
        font-weight: 400;
        color: #000000;
        span {
          color: #c90203;
        }
      }
      div {
        margin-top: 8px;
        margin-bottom: 8px;
        width: 45px;
        height: 2px;
        background: #c90203;
      }
    }
  }
  .craft {
    box-sizing: border-box;
    padding: 25px 15px;
    width: 100%;
    background-color: #e6e8e9;
    ul {
      margin-top: 20px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      li {
        width: 70px;
        height: 34px;
        // margin-right: 5px;
        background: #343434;
        border-radius: 5px;
        font-size: 13px;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    .craft_item {
      margin-top: 15px;
      width: 100%;
      .van-swipe-item {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
  .haipai {
    width: 100%;
    padding: 20px 15px;
    box-sizing: border-box;
    ul {
      margin-top: 10px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 49.5%;
        overflow: hidden;
        margin-bottom: 4px;
        img {
          float: left;
          width: 100%;
        }
        div {
          width: 100%;
          padding: 5px 0px 8px 0px;
          background-color: #e6e8e9;
          border-radius: 0px 0px 4px 4px;
          display: flex;
          flex-direction: column;
          align-items: center;
          p {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 10px;
            font-family: "FZLanTingHei-R-GBK";
            font-weight: 400;
            color: #1a1a1a;
            margin-bottom: 1px;
            text-align: center;
          }
        }
      }
    }
  }
  .team {
    width: 100%;
    background: url(../assets/forum_img/team4.png) no-repeat;
    background-size: cover;
    // background-color: #F3F3F3;
    padding: 30px 15px 20px 15px;
    box-sizing: border-box;
    ul {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 15px;
      li {
        width: 49.5%;
        img {
          width: 100%;
        }
      }
    }
    .team_end {
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;

      // background: url(../assets/forum_img/team3.png) no-repeat;
      // background-size: cover;
      // height: 300px;
      img {
        width: 100%;
        margin-bottom: 8px;
      }
    }
  }
  .map {
    width: 100%;
    padding: 25px 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffe100;
    h5 {
      font-size: 18px;
      margin: 0px;
      margin-bottom: 15px;
    }
    .forum_map {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      ul {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        li {
          width: 90%;
          display: flex;
          // justify-content: center;
          // align-items: center;
          margin-bottom: 8px;
          p {
            width: 80px;
            height: 20px;
            background-color: #c2272d;
            color: #fff;
            border-radius: 10px;
            font-size: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 5px;
          }
          div{
            display: flex;
            flex-direction: column;

            span{
              font-weight: bold;
              font-size: 8px;
              margin-bottom: 2px;
            }
          }
        }
      }
    }
    #container{
      // margin: 0 auto;
      width: 80%;
      height: 200px;
      margin-bottom: 20px;
    }
  }
}
.craft_a {
  background: #ffe100 !important;
  color: #221815 !important;
}
</style>
